<mat-slide-toggle color="primary"
        (change)="changeMqttState()" [checked]="mqttService.currentState()">
    MQTT Live
</mat-slide-toggle>
